module.exports = __webpack_public_path__ + "69cb4b93328857845725e68b033a1ab2.svg";